/**
 * Freeze Bag Collection — Color selector updates variant in add-to-cart form
 */
(function () {
  'use strict';

  function init() {
    document.querySelectorAll('.js-freeze-bag-color').forEach(function (radio) {
      if (radio.dataset.initialized) return;
      radio.dataset.initialized = 'true';
      radio.addEventListener('change', function () {
        var variantId = this.dataset.variantId;
        var form = this.closest('product-card')?.querySelector('form[action*="/cart/add"]');
        if (form && variantId) {
          var idInput = form.querySelector('input[name="id"]');
          if (idInput) idInput.value = variantId;
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
